/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */

import { htmlspecialchars, clip } from './util.js';
import { startProgress, stopProgress } from './progress-util.js';
import { dialogDynWidthFn, getPreferedMaxDialogHeight } from './dialog-util.js';
import { mj } from './page-mj.js';
import { jQuery } from '../other/jquery-hooked.js';
import { mjt } from './i18ntexts.js';

import { MDLocale } from './locale-impl.js';

import { MTemplates } from './templates.js';


export let MVDownloadInfo = function($,mj) {

	function intent_html_1( itm ) {
		switch( itm.dl_intent ) {
		case 'stream':					return mjt('mdli-intent-stream');
		case 'send':					return mjt('mdli-intent-send');
		case 'download':
		case '':						return mjt('mdli-intent-download');

		case 'stream-extern-link':		return mjt('mdli-intent-stream-extern-link');
		case 'stream-api-permalink':	return mjt('mdli-intent-stream-api-permalink');
		case 'stream-ui-permalink':		return mjt('mdli-intent-stream-ui-permalink');

		case 'download-extern-link':	return mjt('mdli-intent-download-extern-link');
		case 'download-api-permalink':	return mjt('mdli-intent-download-api-permalink');
		case 'download-ui-permalink':	return mjt('mdli-intent-download-ui-permalink');
		}
		return htmlspecialchars(itm.dl_intent);
	}

	function intent_html( itm ) {
		const str = intent_html_1(itm);
		const firstWsPos = str.indexOf(' ');
		if( firstWsPos!==-1 ) {
			return str.substr(0,firstWsPos) + '<br>' + str.substr(firstWsPos+1);
		}
		return str;
	}

	function build_table( $tbody, items ) {
		let html = '';
		for( var i=0; i<items.length; ++i ) {
			const itm = items[i];
			html += '<tr class="'+((i%2)===0?'odd':'even')+'">'
					+'<td class="vertical-top text-right">'+MDLocale.fmt_date(itm.dl_dt)+'<small><br />'+MDLocale.fmt_time(itm.dl_dt)+'</small></td>'
					+'<td class="vertical-top text-right">'+(itm.media_id)+'<small><br />'+(itm.media_version)+'</small></td>'
					+'<td class="vertical-top">'+htmlspecialchars(itm.dlf_name)+'</td>'
					+'<td class="vertical-top">'+htmlspecialchars(itm.dl_filename)+'</td>'
					+'<td class="vertical-top text-right">'+(itm.dl_size>0?MDLocale.fmt_filesize(itm.dl_size):'')+'</td>'
					+'<td class="vertical-top text-right">'+intent_html(itm)+'</td>'
					+'<td class="vertical-top">'+htmlspecialchars(itm.user_login+' (ID '+itm.user_id+')')
						+(itm.user_email?('<small><br />'+htmlspecialchars(itm.user_email)+'</small>'):'')
					+'</td>'
				+'</tr>';
		}
		$tbody.html(html);
	}

	function clear_table() {
		const $table = $('#mdli-list > table').detach();
		$table.find('>tbody').empty();
		$table.appendTo('#mdli-list');
	}

	function open( media_ids ) {
		$('#mdli-form').dialog('destroy');
		if( media_ids.length==0 ) return;
		if( media_ids.length==1 ) {
			$('#mdli-form').attr('title',mjt('mdli-title-1').replace('%1',media_ids[0]));
		} else {
			$('#mdli-form').attr('title',mjt('mdli-title-multiple').replace('%1',media_ids.length));
		}
		if( mj.role_administrator || ( mj.role_user && mj.role_manager ) ) {
			$('#mdli-flt-user-all')
				.prop('disabled',false)
				.next('label[for=mdli-flt-user-all]').removeClass('disabled');
		} else {
			$('#mdli-flt-user-all')
				.prop('disabled',true)
				.next('label[for=mdli-flt-user-all]').addClass('disabled');
		}
		$('#mdli-flt-user-me,#mdli-flt-user-all').off().click( function() {
			const flt_user_id = $(this).val();
			// clear list
			clear_table();
			// load list of downloads...
			startProgress();
			$.postJSON( 'json/media/manage-media_downloads_list', 'media_ids='+encodeURIComponent(media_ids.join(','))+'&flt_user_id='+encodeURIComponent(flt_user_id), function(j) {
				stopProgress();
				$('#mdli-form').dialog('destroy');
				if( j && j.hasOwnProperty('media_downloads_list') ) {
					// compute max dialog height
					const mh = clip( getPreferedMaxDialogHeight() + 0, 180, 1200 );
					// show dialog
					$('#mdli-form').dialog( {
						width: dialogDynWidthFn(600,1800),//mw,
						height: mh,
						modal: true,
						resizable: false,
						close: function(ev, ui) {
							clear_table();
							$(this).dialog('destroy');
						},
						open: function(ev,ui) {
							const $table = $('#mdli-list > table').detach();
							build_table( $table.find('>tbody'), j.media_downloads_list );
							$table.appendTo('#mdli-list');
							requestAnimationFrame( function() {
								const oh = clip( 180 + ($('#mdli-list:visible').height()||0), 180, mh );
								$('#mdli-form')
									.dialog('option','height',oh)
									.dialog('option','position',{my:'center',at:'center',of:window});
							} );
						}
					} ).show();
				}
			} );
		} );
		if( mj.role_administrator || ( mj.role_user && mj.role_manager ) ) {
			$('#mdli-flt-user-all').prop('checked',true).click();
		} else {
			$('#mdli-flt-user-me').prop('checked',true).click();
		}
	}

	return {
		open: MTemplates.queryDialogHTMLWrappedFn('form_media_download_info',open),
	};

}(jQuery,mj); // namespace MVDownloadInfo
